var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteAudit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.528 14.9001H13.114L12.162 12.2121H7.80797L6.84197 14.9001H5.46997L9.16597 5.1001H10.902L14.528 14.9001ZM9.27797 8.1101L8.21397 11.0641H11.742L10.692 8.1101C10.426 7.3541 10.286 6.8081 10.272 5.9821H9.71197C9.68397 6.8081 9.55797 7.3541 9.27797 8.1101Z",
    fill: "#222229"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteAudit);
export default __webpack_public_path__ + "static/media/white-audit.510cdcc30b72d6fac3c6da6d4ed5b7a4.svg";
export { ForwardRef as ReactComponent };